import { render, staticRenderFns } from "./BusdevDashboard.vue?vue&type=template&id=b6365a4c&scoped=true"
import script from "./BusdevDashboard.vue?vue&type=script&lang=js"
export * from "./BusdevDashboard.vue?vue&type=script&lang=js"
import style0 from "./BusdevDashboard.vue?vue&type=style&index=0&id=b6365a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6365a4c",
  null
  
)

export default component.exports